import { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useInView } from "../../hooks/useInView";
import { incrementByAmount } from "../counter/counterSlice";
import { useFetchBreedsQuery } from "./catsApiSlice";

const Cats: FC = () => {
	const dispatch = useAppDispatch();
	const counter = useAppSelector(state => state.counter.value);

	const inViewRef = useInView(() => {
		dispatch(incrementByAmount(5));
	});

	const { data } = useFetchBreedsQuery(counter);

	return (
		<div>
			<p>Number of Cats fetched: {data?.length}</p>

			<table>
				<tbody>
					{data?.map(breed => (
						<tr key={breed.id}>
							<td>
								<img
									width={360}
									src={breed.image?.url ?? ""}
									alt={breed.name}
								/>
							</td>
						</tr>
					))}

					<tr>
						<td>
							<div ref={inViewRef} />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export { Cats };
